import { mapMutationsFromTypes } from 'schepotin-vuex-helpers';
import * as types from './mutation-types';

export default {
    /**
     * Generates {@link https://vuex.vuejs.org/en/mutations.html | mutations} from
     * {@link https://vuex.vuejs.org/en/mutations.html#using-constants-for-mutation-types | mutation types}
     *
     * Documentation
     * {@link https://www.npmjs.com/package/schepotin-vuex-helpers#mapmutationsfromtypes | mapMutationsFromTypes}
     */
    ...mapMutationsFromTypes({
        types,
        excludes: [
            types.TERMINAL_DATA,
            types.CLEAR_TERMINAL_DATA,
            types.ADD_SCANNED,
        ],
    }),
    [types.TERMINAL_DATA](state, payload) {
        state.terminalData = [
            ...state.terminalData,
            payload,
        ];
    },
    [types.ADD_SCANNED](state, payload) {
        state.scanned = [
            ...state.scanned,
            payload,
        ];
    },
    [types.CLEAR_TERMINAL_DATA](state) {
        state.terminalData = [];
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/device/mutations.js